
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ResepObatSvc from "@/services/ResepObat";

@Component
export default class ObatComboField extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: null }) obatId!: string | null;
  @Prop({ default: "Nama Obat" }) label!: string;
  @Prop({ default: "Ketik min. 3 huruf untuk mencari" }) placeholder!: string;
  @Prop({ default: null }) kategori!: string | null;
  @Prop({ default: true }) dense!: boolean;
  @Prop({ default: false }) outlined!: boolean;
  @Prop({ default: false }) singleLine!: boolean;
  @Prop({ default: false }) disabled!: boolean;

  search: string | null = null;
  entries: any[] = [];
  isLoading = false;
  selectedItem: any = null;
  private _timerId: any = null;

  mounted() {
    this.hydrate();
  }

  @Watch("value")
  onValueChanged(val: string) {
    const current = this.currentText();
    if (val !== current) this.hydrate();
  }

  currentText(): string {
    if (!this.selectedItem) return "";
    return typeof this.selectedItem === "string"
      ? this.selectedItem
      : this.selectedItem.nama || "";
  }

  hydrate() {
    if (this.value) {
      const item = {
        nama: this.value,
        label: this.value,
        id: this.obatId || null
      };
      this.entries = [item];
      this.$nextTick(() => {
        this.selectedItem = item;
      });
    } else {
      this.entries = [];
      this.$nextTick(() => {
        this.selectedItem = null;
      });
    }
  }

  onChange(val: any) {
    if (val && typeof val === "object") {
      this.$emit("input", val.nama || "");
      this.$emit("update:obat-id", val.id || null);
      this.$emit("select", val);
    } else {
      const text = val || "";
      this.$emit("input", text);
      if (text !== this.value || this.obatId) this.$emit("update:obat-id", null);
    }
  }

  @Watch("search")
  onSearchChanged(val: string | null) {
    clearTimeout(this._timerId);

    if (!val || val.length < 3 || val === this.value) return;

    this._timerId = setTimeout(() => {
      this.isLoading = true;
      ResepObatSvc.getRefObat(val, this.kategori)
        .then((res: any) => {
          this.entries = res.data || [];
        })
        .catch(() => {
          this.entries = [];
        })
        .finally(() => (this.isLoading = false));
    }, 300);
  }
}
